import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source", "output", "success"]

  async copy(e) {
    e.preventDefault()

    try {
      this.sourceTarget.select()
      document.execCommand("copy")

      if (this.hasOutputTarget) {
        this.outputTarget.innerHTML = "Copied!"
      }

      this.dispatch("copied", { detail: { source: this.sourceTarget } })
    } catch (e) {
      console.error(e)
      alert(`Could not copy to clipboard.`)
      return
    }
  }
}
